









import { Prop, Component, Vue } from "vue-property-decorator";
import { Confidence as ConfidenceClass } from "@/types/NewResults";
import AwkPause from "./confidence/AwkPause.vue";
import FillerPercent from "./confidence/FillerPercent.vue";
import Uncertainty from "./confidence/Uncertainty.vue";

@Component({
  components: { AwkPause, FillerPercent, Uncertainty }
})
export default class Confidence extends Vue {
  @Prop() private confidence!: ConfidenceClass;
}
